import { useState } from "react";
import Footer from "../../../component/Footer";
import Navbar from "../../../component/Navbar";
import CountdownComponent from "../../../component/CountdownComponent";

const Voicecall = () => {
  const pickedTherapist = JSON.parse(localStorage.getItem("pickedTherapist"));
  return (
    <div>
      <Navbar />

      <section className="bg-[#D4DDCC] flex items-start gap-12 px-8 py-4 h-[100vh]">
        <div className="hidden md:block w-2/7 self-stretch relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-full bg-[rgba(220,174,150,0.7)] z-10 rounded-md" />
          <div className="w-full px-2 py-4 rounded-md h-full">
            <h1 className="text-green-500 font-semibold text-lg px-2 mb-2">
              Current Therapist
            </h1>
            <div className="bg-[#fff] rounded-md px-2 py-1 flex items-center gap-4 mb-8">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSrBp4rAadRiXmk6NWl3redkvGJgWGDkBT4vA&usqp=CAU"
                alt=""
                className="w-12 h-12 rounded-full"
              />
              <div className>
                <h1 className="text-green-500 font-semibold text-lg">
                  {pickedTherapist.user.lastName[0]}.&nbsp;
                  {pickedTherapist.user.firstName}
                </h1>
                <p className="text-green-500">
                  {pickedTherapist.specialization}
                </p>
              </div>
            </div>
            {/* <h1 className="text-green-500 font-semibold text-lg px-2 mb-2">
              Previous Therapists
            </h1> */}
            {/* <div className="flex flex-col gap-4">
              <div className="bg-[#fff] rounded-md px-2 py-1 flex items-center gap-4">
                <img
                  src="https://res.cloudinary.com/druryt8ny/image/upload/v1701390510/wajud%20on%20call%20pages.png"
                  alt="wajud"
                  className="w-12 h-12 rounded-full"
                />
                <div className="bg-[#fff]">
                  <h1 className="text-green-500 font-semibold text-lg">
                    K. Wajud
                  </h1>
                  <p className="text-green-500">Senior At Therapy</p>
                </div>
              </div>
              <div className="bg-[#fff] rounded-md px-2 py-2 flex items-center gap-4">
                <img
                  src="https://res.cloudinary.com/druryt8ny/image/upload/v1701389862/rahmat%20on%20call%20pages.png"
                  alt="rahmat"
                  className="w-12 h-12 rounded-full"
                />
                <div className="bg-[#fff]">
                  <h1 className="text-green-500 font-semibold text-lg">
                    P. Rahmat
                  </h1>
                  <p className="text-green-500">Senior At Therapy</p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
        <div className="bg-[#DCAE96] w-full md:w-[65%] mt-12">
          <div className="px-4 py-1 bg-[#295700]">
            <img
              src="https://res.cloudinary.com/druryt8ny/image/upload/v1700518851/rsnuvxsp8itnttc6hk9u.png"
              alt="logo"
              className="w-8 h-8 object-cover"
            />
          </div>
          <div className="bg-[#D4DDCC] flex flex-col items-center justify-center min-h-[50vh] m-2 mr-4 ml-4 rounded-lg">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSrBp4rAadRiXmk6NWl3redkvGJgWGDkBT4vA&usqp=CAU"
              alt="musa"
              className="w-28 h-28 rounded-full mb-2"
            />
            <h1 className="text-2xl font-bold text-center text-green-700">
              {pickedTherapist.user.lastName[0]}.&nbsp;
              {pickedTherapist.user.firstName}
            </h1>
            {/* <h1 className="text-lg font-semibold text-center text-[#E60E1B]">
             
            </h1> */}
            <CountdownComponent></CountdownComponent>
          </div>
          <div className="flex justify-center gap-4 my-2">
            <div className="bg-[#D4DDCC] px-2 py-2 rounded-full">
              <img
                src="https://res.cloudinary.com/druryt8ny/image/upload/v1701389753/microphone.png"
                alt="Microphone"
                className="w-4 h-4 rounded-full"
              />
            </div>
            <div className="bg-[#D4DDCC] min-w-fit px-1 py-1 rounded-full flex items-center justify-center">
              <img
                src="https://res.cloudinary.com/druryt8ny/image/upload/v1701389588/end%20call.png"
                alt="end-call"
                className="scale-75 object-cover rounded-full"
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Voicecall;
